import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_HOLIDAY_REQUESTS = restRequest("GET_HOLIDAY_REQUESTS");
export const SET_HOLIDAY_REQUEST = restRequest("SET_HOLIDAY_REQUEST");
